const SMART_SECTIONS = {
  SMART_SECTIONS: '/smart-sections',
  SMART_SECTIONS_CREATE: '/smart-sections/create',
  SMART_SECTIONS_GROUP: '/smart-sections/group/:identifier'
}

export default SMART_SECTIONS
